import React, {useEffect} from "react";
import makeStyles from '@mui/styles/makeStyles';
import Tooltip from '@mui/material/Tooltip';
import {AutocompleteDictionary} from "./autocomplete";
import API from "../../app/api";
import _ from "lodash";
import config from "../../app/config";

export const useStyles = makeStyles((theme) => ({
    accordion: {
        backgroundColor: theme.palette.accordion.backgroundColor,
        marginBottom: 10,
    },
    colorSystem: {
        width: 16,
        height: 16,
        backgroundColor: 'white',
        display: "inline-block",
        marginRight: 10,
        verticalAlign: 'middle',
        border: "1px solid #222",
    },
    colorSystemTextBox: {
        width: 16,
        height: 16,
        backgroundColor: 'white',
        display: "inline-block",
        marginRight: 5,
        marginLeft: 5,
        verticalAlign: 'middle',
        border: "1px solid #222",
    },
    discriminator: {
        display: "inline-block",
        // height: 16,
        verticalAlign: 'middle'
    },
    dialogMainContent: {
        backgroundColor: theme.palette.background.default,
        "&.header": {
            paddingTop: 5,
            paddingBottom: 0,
        }
    },
    snomedCode: {
        marginRight: 10,
        padding: "2px 7px",
        backgroundColor: theme.palette.background.default,
        borderRadius: 10,
        fontSize: "80%"
    },
    sensitiveDescr: {
        marginLeft: 10,
        padding: "2px 7px",
        backgroundColor: theme.palette.background.default
    },

    triageSymbol: {
        position: "relative",
        verticalAlign: "middle",
        display: "inline-block",
        width: 20,
        height: 20,
        // backgroundColor: 'blue',
        marginTop: -2,
        marginRight: 10,
        border: "1px solid " + theme.palette.grey[400]
    },
    triageTime: {
        fontWeight: "normal",
        marginLeft: 10,
        fontSize: "90%"
    },
    datePicker: {
        width: "100%",
        // padding: "auto"
    },
    inputLabel: {
        height: 41
    },
    infoObs: {
        color: "#434343",
        fontSize: "medium",
        textAlign: "center",
        fontWeight: "bold",
        background: "#ffd966",
        padding: 5,
        borderRadius: 5,
        marginTop: 20
    },
    headCell: {
        fontSize: "12px",
        background: theme.palette.background.default,
    },
    rowCell: {
        fontSize: "small",
    },
    flagContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
    },
    flagTitle: {
        display: "flex",
        alignItems: "center",
        // width: "100%",
        minWidth: 150,
        gap: 5,
        fontWeight: "bold",
        // borderBottom: "1px solid #b7b7b7",
        padding: "1px 0px 1px 5px"
    },
    dictInput: {
        width: "100%",
        fontSize: "15px",
        marginTop: 10,
        backgroundColor: theme.palette.background.paper,
        borderRadius: "6%"
    },
    error:{
        color: "#f44336"
    },
    loading: {
        textAlign: "center",
        fontWeight: "bold"
    },
    paper: {
        background: theme.palette.background.paper,
        margin: "10px 0px 0px 15px",
        padding: 10,
        width: "100%",
        display: "grid",
        gridGap: 10,
    },
    infoPt: {
        width: "calc(25% - 10px)",
        margin: 5,
    },
    regularButtonsSection: {
        textAlign: "right",
        marginBottom: "-4px",
        display: 'flex'
    },
    regularButton: {
        margin: "2px 5px",
        padding: "4px 8px 0px 8px"
    },
    nkdaButton: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
    },
    safeguardingSwitch: {
        display: 'flex',
        alignItems: 'center',
        gap: 10
    },
    marginLeft: {
        marginLeft: 5,
    },
    divRow: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
    },
    divider: {
        background: theme.palette.background.paper,
        margin: "10px 0",
    }
}));

// Presentation
function ControlPresentation(props) {
    const getDictionaryURL = filter => {
        let newFilter = `mtsVersion eq '${config.mtsVersion}'`;
        if (filter !== "") {
            newFilter = `mtsVersion eq '${config.mtsVersion}' and ` + filter
        }

        return `/$dict/TriagePresentations?$filter=${encodeURIComponent(newFilter)}&$sort=sort`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        const parts = createParts(option.__description);

        return (
            <div {...inp}>
                <div className={classes.snomedDescription}>
                    {parts.map((part, index) => (
                        <span key={index} style={{
                            textDecoration: part.highlight ? 'underline' : 'none',
                            fontWeight: part.highlight ? 700 : 400
                        }}>
                            {part.text}
                        </span>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <AutocompleteDictionary showAll
            getOptionSelected={(option, value) => option.__description === value.__description}
            getOptionLabel={(option) => option.__description}
            renderLocalOption={renderOptionLine} searchColumnName={"description"} dictionaryURL={getDictionaryURL} {...props} />
    )
}

// Discriminator
function ControlDiscriminator(props) {
    const classesLocal = useStyles();
    const presentationCode = (props.presentation && props.presentation.__code) ? props.presentation.__code : null;

    const getDictionaryURL = filter => {
        let localFilter = `mtsVersion eq '${config.mtsVersion}'`;
        if (filter !== "") {
            localFilter = `mtsVersion eq '${config.mtsVersion}' and ` + filter
        }
        localFilter += ` and presentation eq '${presentationCode}'`;

        return `/$dict/TriageDiscriminators?$filter=${encodeURIComponent(localFilter)}&$sort=priority,sort,sort2`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        const parts = createParts(option.__description);

        return (
            <div {...inp}>
                {/* FIXME: display what group ???? maybe - single step ??? */}
                <div className={classesLocal.colorSystem} style={{
                    backgroundColor: option.color.toLowerCase(),
                }}>
                </div>
                <div className={classesLocal.discriminator}>
                    {parts.map((part, index) => (
                    <Tooltip key={index} title={option.details} placement="right-end">
                        <span key={index} style={{
                            textDecoration: part.highlight ? 'underline' : 'none',
                            fontWeight: part.highlight ? 700 : 400
                        }}>
                            {part.text}
                        </span>
                    </Tooltip>
                    ))}
                </div>
            </div>
        );
    };

    const renderOptionColor = () => {
        const colorValue = props.value ? props.value.color.toLowerCase() : null;
        if (!colorValue) {
            return undefined;
        }
        return (
            <div
                style={{
                    backgroundColor: colorValue
                }}
                className={classesLocal.colorSystemTextBox}></div>
        );
    };

    return (
        <AutocompleteDictionary showAll
            startTextBoxAdornment={renderOptionColor}
            disabled={!presentationCode}
            filterCode={presentationCode}
            getOptionSelected={(option, value) => option.__description === value.__description}
            getOptionLabel={(option) => option.__description}
            renderLocalOption={renderOptionLine} searchColumnName={"description"} dictionaryURL={getDictionaryURL} {...props} />
    )
}

// Dependency
function ControlDependency(props) {
    const classesLocal = useStyles();
    const controller = new AbortController();

    useEffect(async () => {
        if (props.setDefault && !props.value) {
            await API.getDictByURL("/$dict/TriageDependencies", controller.signal)
                .then((response) => {
                    if (!_.isEmpty(response.__data)) {
                        props.onChange(_.find(response.__data, {color: "green"}), true);
                    }
                });
        }
        return () => {
            controller.abort();
        };
    }, []);

    const getDictionaryURL = filter => {
        return `/$dict/TriageDependencies?$filter=${encodeURIComponent(filter)}&$sort=code`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        const parts = createParts(option.__description);

        return (
            <div {...inp}>
                <div className={classesLocal.colorSystem} style={{
                    backgroundColor: option.color.toLowerCase(),
                }}>
                </div>
                <div className={classesLocal.discriminator}>
                    {parts.map((part, index) => (
                        <span key={index} style={{
                            textDecoration: part.highlight ? 'underline' : 'none',
                            fontWeight: part.highlight ? 700 : 400
                        }}>
                            {part.text}
                        </span>
                    ))}
                </div>
            </div>
        );
    };

    const renderOptionColor = () => {
        const colorValue = props.value ? props.value.color.toLowerCase() : null;
        if (!colorValue) {
            return undefined;
        }
        return (
            <div
                style={{
                    backgroundColor: colorValue
                }}
                className={classesLocal.colorSystemTextBox}></div>
        );
    };

    return (
        <AutocompleteDictionary showAll
            getOptionSelected={(option, value) => option.__description === value.__description}
            getOptionLabel={(option) => option.__description}
            startTextBoxAdornment={renderOptionColor}
            renderLocalOption={renderOptionLine}
            searchColumnName={"description"}
            dictionaryURL={getDictionaryURL} {...props} />
    )
}

export {
    ControlPresentation,
    ControlDiscriminator,
    ControlDependency
};
